import Swiper from 'swiper'; 
import { Autoplay } from 'swiper/modules';

function dm_a_01_explore_sectors(options = {}) {
  const ul = document.querySelector( 'section.a-01-explore-sectors .sectors ul' );

  if (!ul) return;

  const container = ul.parentElement;
  container.classList.add('swiper', 'sector-ticker');
  ul.classList.add('swiper-wrapper');
  ul.querySelectorAll('li').forEach(li => li.classList.add('swiper-slide'));

  const swiper = new Swiper(container, {
    modules: [Autoplay],
    direction: 'vertical',
    loop: true,
    slidesPerView: 3,               // show exactly three sector names at rest
    slidesPerGroup: 1,              // advance one sector at a time
    spaceBetween: 0,
    speed: 600,                     // slide animation time
    allowTouchMove: false,          // auto-ticking list
    autoplay: {
      delay: 1800,                  // pause time on the arrow
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    observer: true,
    observeParents: true,
    on: {
      init(s) { markActive(s); },
      slideChangeTransitionEnd(s) { markActive(s); }
    }
  });

  function markActive(s) {

    s.slides.forEach(slide => slide.classList.remove('is-active'));
    const active = s.slides[s.activeIndex];
    if (active) active.classList.add('is-active');
  }

  // pause when offscreen
  const io = new IntersectionObserver(([e]) => {
        if (!e) return;
        e.isIntersecting ? swiper.autoplay.start() : swiper.autoplay.stop();
    }, { threshold: 0.1 });
  io.observe(container);
}

export { dm_a_01_explore_sectors };
